export const BOOKING_PORTAL_CSS = `
.site-booking{
  --booking-soft:color-mix(in srgb,var(--site-primary) 7%,var(--site-surface));
  --booking-soft-strong:color-mix(in srgb,var(--site-primary) 13%,var(--site-surface));
  --booking-shadow:0 24px 65px color-mix(in srgb,var(--site-text) 10%,transparent);
  color:var(--site-text);
  font-family:var(--site-body-font);
  margin-inline:auto;
  width:100%
}
.site-booking *{box-sizing:border-box}
.site-booking button,.site-booking input,.site-booking select,.site-booking textarea{font:inherit}
.site-booking button{touch-action:manipulation}
.site-booking__shell{
  background:var(--site-surface);
  border:1px solid var(--site-border);
  border-radius:clamp(18px,calc(var(--site-radius) * 1.35),32px);
  box-shadow:var(--booking-shadow);
  overflow:hidden
}
.site-booking__intro{
  align-items:flex-start;
  background:linear-gradient(135deg,var(--booking-soft),var(--site-surface) 64%);
  border-bottom:1px solid var(--site-border);
  display:flex;
  gap:24px;
  justify-content:space-between;
  padding:clamp(22px,4vw,42px)
}
.site-booking__intro-copy{display:grid;gap:8px;max-width:680px}
.site-booking__eyebrow{
  color:var(--site-primary);
  font-size:.72rem;
  font-weight:850;
  letter-spacing:.11em;
  text-transform:uppercase
}
.site-booking__intro h2,.site-booking__section-heading h2,.site-booking__checkout h2,.site-booking__success h2{
  font-family:var(--site-heading-font);
  margin:0
}
.site-booking__intro h2{font-size:clamp(1.55rem,3.3vw,2.55rem);line-height:1.08}
.site-booking__intro p,.site-booking__section-heading p,.site-booking__checkout-copy,.site-booking__empty{
  color:var(--site-muted);
  line-height:1.6;
  margin:0
}
.site-booking__intro-icon{
  align-items:center;
  background:var(--site-primary);
  border-radius:18px;
  box-shadow:0 14px 28px color-mix(in srgb,var(--site-primary) 24%,transparent);
  color:var(--site-on-primary,#fff);
  display:flex;
  flex:0 0 auto;
  height:58px;
  justify-content:center;
  transform:rotate(3deg);
  width:58px
}
.site-booking__intro-icon svg{height:27px;width:27px}
.site-booking__progress{
  background:var(--site-surface);
  border-bottom:1px solid var(--site-border);
  display:grid;
  grid-template-columns:repeat(var(--booking-step-count),minmax(0,1fr));
  list-style:none;
  margin:0;
  padding:0 clamp(16px,4vw,42px)
}
.site-booking__progress li{min-width:0;position:relative}
.site-booking__progress li:not(:last-child)::after{
  background:var(--site-border);
  content:"";
  height:2px;
  left:calc(50% + 20px);
  position:absolute;
  right:calc(-50% + 20px);
  top:24px
}
.site-booking__progress li[data-complete=true]:not(:last-child)::after{background:var(--site-primary)}
.site-booking__progress-button{
  align-items:center;
  background:transparent;
  border:0;
  color:var(--site-muted);
  display:flex;
  flex-direction:column;
  font-size:.74rem;
  font-weight:750;
  gap:7px;
  min-width:0;
  padding:14px 6px 16px;
  position:relative;
  text-align:center;
  width:100%;
  z-index:1
}
.site-booking__progress-button:not(:disabled){cursor:pointer}
.site-booking__progress-number{
  align-items:center;
  background:var(--site-surface);
  border:1px solid var(--site-border);
  border-radius:50%;
  display:flex;
  font-size:.72rem;
  height:22px;
  justify-content:center;
  transition:background .18s,border-color .18s,color .18s;
  width:22px
}
.site-booking__progress li[data-active=true] .site-booking__progress-button{color:var(--site-text)}
.site-booking__progress li[data-active=true] .site-booking__progress-number,
.site-booking__progress li[data-complete=true] .site-booking__progress-number{
  background:var(--site-primary);
  border-color:var(--site-primary);
  color:var(--site-on-primary,#fff)
}
.site-booking__body{padding:clamp(20px,4vw,42px)}
.site-booking__workspace{align-items:start;display:grid;gap:clamp(20px,3vw,34px);grid-template-columns:minmax(0,1fr)}
.site-booking__workspace[data-with-summary=true]{grid-template-columns:minmax(0,1.75fr) minmax(230px,.75fr)}
.site-booking__main{display:grid;gap:22px;min-width:0}
.site-booking__section-heading{display:grid;gap:7px}
.site-booking__section-heading h2{font-size:clamp(1.35rem,2.5vw,1.95rem)}
.site-booking__section-heading-row{align-items:flex-end;display:flex;gap:16px;justify-content:space-between}
.site-booking__count{
  background:var(--booking-soft);
  border-radius:999px;
  color:var(--site-primary);
  flex:0 0 auto;
  font-size:.75rem;
  font-weight:800;
  padding:7px 11px
}
.site-booking__cards{display:grid;gap:13px;grid-template-columns:repeat(auto-fit,minmax(min(235px,100%),1fr))}
.site-booking__card{
  background:color-mix(in srgb,var(--site-primary) 2.5%,var(--site-surface));
  border:1px solid transparent;
  border-radius:max(14px,var(--site-radius));
  color:var(--site-text);
  cursor:pointer;
  display:grid;
  gap:11px;
  min-height:142px;
  padding:18px;
  position:relative;
  text-align:left;
  box-shadow:inset 0 0 0 1px color-mix(in srgb,var(--site-border) 72%,transparent);
  transition:background .18s,border-color .18s,box-shadow .18s,transform .18s
}
.site-booking__card:hover{background:var(--booking-soft);box-shadow:inset 0 0 0 1px color-mix(in srgb,var(--site-primary) 22%,transparent),0 14px 30px color-mix(in srgb,var(--site-text) 6%,transparent);transform:translateY(-2px)}
.site-booking__card:focus-visible,.site-booking__date:focus-visible,.site-booking__calendar-nav:focus-visible,.site-booking__time:focus-visible,.site-booking__button:focus-visible,.site-booking__progress-button:focus-visible,.site-booking__schedule-slot:focus-visible,.site-booking__venue-services>button:focus-visible,.site-booking__venue-resource-select select:focus-visible,.site-booking__date-jump-toggle:focus-visible,.site-booking__week-navigation button:focus-visible,.site-booking__venue-slot:focus-visible,.site-booking__venue-day-tabs button:focus-visible,.site-booking__venue-agenda>button:focus-visible,.site-booking__quick-services>button:focus-visible,.site-booking__quick-day button:focus-visible,.site-booking__dialog-close:focus-visible{
  outline:3px solid color-mix(in srgb,var(--site-primary) 30%,transparent);
  outline-offset:2px
}
.site-booking__card[data-selected=true]{background:var(--booking-soft);border-color:color-mix(in srgb,var(--site-primary) 58%,transparent);box-shadow:0 0 0 3px color-mix(in srgb,var(--site-primary) 12%,transparent)}
.site-booking__card-top{align-items:flex-start;display:flex;gap:12px;justify-content:space-between}
.site-booking__service-icon{
  align-items:center;
  background:var(--booking-soft);
  border-radius:12px;
  color:var(--site-primary);
  display:flex;
  height:40px;
  justify-content:center;
  width:40px
}
.site-booking__service-icon svg{height:20px;width:20px}
.site-booking__selection-mark{
  align-items:center;
  border:1px solid var(--site-border);
  border-radius:50%;
  color:transparent;
  display:flex;
  height:24px;
  justify-content:center;
  width:24px
}
.site-booking__card[data-selected=true] .site-booking__selection-mark{background:var(--site-primary);border-color:var(--site-primary);color:var(--site-on-primary,#fff)}
.site-booking__selection-mark svg{height:14px;width:14px}
.site-booking__card strong{font-family:var(--site-heading-font);font-size:1.04rem;line-height:1.3}
.site-booking__card-copy{display:grid;gap:7px}
.site-booking__cards .site-booking__selection-mark{position:absolute;right:18px;top:18px}
.site-booking__description{color:var(--site-muted);font-size:.86rem;line-height:1.55;margin:0}
.site-booking__meta{align-items:center;color:var(--site-muted);display:flex;flex-wrap:wrap;font-size:.78rem;gap:8px 14px}
.site-booking__meta-item{align-items:center;display:flex;gap:5px}
.site-booking__meta svg{height:14px;width:14px}
.site-booking__price{color:var(--site-text);font-weight:800}
.site-booking__service-list{border-block:1px solid var(--site-border);display:grid}
.site-booking__service-list .site-booking__card{align-items:center;background:transparent;border:0;border-bottom:1px solid var(--site-border);border-radius:0;box-shadow:none;gap:16px;grid-template-columns:auto minmax(0,1fr) auto;min-height:0;padding:17px 4px}
.site-booking__service-list .site-booking__card:last-child{border-bottom:0}
.site-booking__service-list .site-booking__card:hover{background:var(--booking-soft);box-shadow:0 0 0 10px var(--booking-soft);transform:none}
.site-booking__service-list .site-booking__card[data-selected=true]{background:var(--booking-soft);box-shadow:0 0 0 10px var(--booking-soft)}
.site-booking__service-list .site-booking__card-copy{display:grid;gap:5px}
.site-booking__service-list .site-booking__selection-mark{grid-column:3;grid-row:1;position:static}
.site-booking__resources{display:grid;gap:14px;grid-template-columns:repeat(auto-fit,minmax(min(205px,100%),1fr))}
.site-booking__resource{
  align-content:start;
  background:linear-gradient(155deg,color-mix(in srgb,var(--booking-accent,var(--site-primary)) 10%,var(--site-surface)),var(--site-surface) 70%);
  min-height:190px
}
.site-booking__resource::before{
  background:var(--booking-accent,var(--site-primary));
  border-radius:999px;
  content:"";
  height:3px;
  left:18px;
  position:absolute;
  right:18px;
  top:0
}
.site-booking__avatar{
  align-items:center;
  background:color-mix(in srgb,var(--booking-accent,var(--site-primary)) 16%,var(--site-surface));
  border:1px solid color-mix(in srgb,var(--booking-accent,var(--site-primary)) 25%,var(--site-border));
  border-radius:50%;
  color:var(--booking-accent,var(--site-primary));
  display:flex;
  font-family:var(--site-heading-font);
  font-size:1.15rem;
  font-weight:850;
  height:54px;
  justify-content:center;
  width:54px
}
.site-booking__resource-role{color:var(--site-primary);font-size:.7rem;font-weight:850;letter-spacing:.08em;text-transform:uppercase}
.site-booking__any-resource{background:var(--booking-soft)}
.site-booking__any-resource .site-booking__avatar{background:var(--booking-soft);color:var(--site-primary)}
.site-booking__date-panel{display:grid;gap:13px;max-width:520px;width:100%}
.site-booking__calendar-header{align-items:flex-end;border-bottom:1px solid var(--site-border);display:flex;gap:16px;justify-content:space-between;padding-bottom:12px}
.site-booking__calendar-title{display:grid;gap:3px}
.site-booking__calendar-title>strong{font-size:.76rem;font-weight:800;letter-spacing:.04em;text-transform:uppercase}
.site-booking__calendar-month{font-family:var(--site-heading-font);font-size:1.12rem;font-weight:800;text-transform:capitalize}
.site-booking__calendar-navigation{display:flex;gap:4px}
.site-booking__calendar-nav{
  align-items:center;
  background:transparent;
  border:0;
  border-radius:999px;
  color:var(--site-text);
  cursor:pointer;
  display:flex;
  height:38px;
  justify-content:center;
  padding:0;
  transition:background .18s,color .18s;
  width:38px
}
.site-booking__calendar-nav:hover{background:var(--booking-soft);color:var(--site-primary)}
.site-booking__calendar-nav:disabled{color:var(--site-muted);cursor:not-allowed;opacity:.34}
.site-booking__calendar-nav svg{height:18px;width:18px}
.site-booking__calendar-nav--next svg{transform:rotate(180deg)}
.site-booking__calendar-weekdays,.site-booking__calendar-grid{display:grid;gap:4px;grid-template-columns:repeat(7,minmax(0,1fr))}
.site-booking__calendar-weekday{color:var(--site-muted);font-size:.67rem;font-weight:800;padding-block:3px;text-align:center;text-transform:uppercase}
.site-booking__date{
  align-items:center;
  aspect-ratio:1;
  background:transparent;
  border:0;
  border-radius:12px;
  color:var(--site-text);
  cursor:pointer;
  display:grid;
  min-height:42px;
  padding:5px;
  place-items:center;
  position:relative;
  transition:background .18s,box-shadow .18s,color .18s,transform .18s
}
.site-booking__date:hover:not(:disabled){background:var(--booking-soft);color:var(--site-primary);transform:translateY(-1px)}
.site-booking__date[data-selected=true]{background:var(--site-primary);box-shadow:0 8px 18px color-mix(in srgb,var(--site-primary) 24%,transparent);color:var(--site-on-primary,#fff)}
.site-booking__date[data-today=true]:not([data-selected=true]){box-shadow:inset 0 0 0 1.5px color-mix(in srgb,var(--site-primary) 58%,transparent);color:var(--site-primary)}
.site-booking__date[data-outside-month=true]{opacity:.36}
.site-booking__date:disabled{cursor:not-allowed;opacity:.18}
.site-booking__date-day{font-family:var(--site-heading-font);font-size:.94rem;line-height:1}
.site-booking__date-dot{background:var(--site-primary);border-radius:50%;bottom:6px;height:4px;left:50%;position:absolute;transform:translateX(-50%);width:4px}
.site-booking__date[data-selected=true] .site-booking__date-dot{background:var(--site-on-primary,#fff)}
.site-booking__time-groups{display:grid;gap:18px}
.site-booking__time-group{display:grid;gap:9px}
.site-booking__time-group-title{align-items:center;color:var(--site-muted);display:flex;font-size:.75rem;font-weight:800;gap:8px;text-transform:uppercase}
.site-booking__time-group-title::after{background:var(--site-border);content:"";height:1px;flex:1}
.site-booking__times{display:grid;gap:8px;grid-template-columns:repeat(auto-fill,minmax(82px,1fr))}
.site-booking__time{
  background:var(--booking-soft);
  border:0;
  border-radius:999px;
  color:var(--site-text);
  cursor:pointer;
  font-weight:750;
  min-height:44px;
  padding:9px 11px;
  text-align:center;
  transition:background .18s,box-shadow .18s,color .18s,transform .18s
}
.site-booking__time:hover{background:var(--booking-soft-strong);color:var(--site-primary);transform:translateY(-1px)}
.site-booking__time[data-selected=true]{background:var(--site-primary);box-shadow:0 8px 18px color-mix(in srgb,var(--site-primary) 22%,transparent);color:var(--site-on-primary,#fff)}
.site-booking__aside{position:sticky;top:18px}
.site-booking__summary{background:var(--booking-soft);border:0;border-radius:max(16px,var(--site-radius));display:grid;gap:15px;padding:20px}
.site-booking__summary-title{align-items:center;display:flex;font-family:var(--site-heading-font);font-size:.93rem;font-weight:800;gap:8px}
.site-booking__summary-title svg{color:var(--site-primary);height:18px;width:18px}
.site-booking__summary-row{border-top:1px solid color-mix(in srgb,var(--site-border) 75%,transparent);display:grid;gap:3px;padding-top:12px}
.site-booking__summary-row span{color:var(--site-muted);font-size:.72rem;font-weight:700;text-transform:uppercase}
.site-booking__summary-row strong{font-size:.9rem;line-height:1.4}
.site-booking__summary-empty{color:var(--site-muted);font-size:.82rem;line-height:1.5}
.site-booking__back{
  align-items:center;
  background:transparent;
  border:0;
  color:var(--site-primary);
  cursor:pointer;
  display:inline-flex;
  font-size:.82rem;
  font-weight:800;
  gap:6px;
  justify-self:start;
  padding:0
}
.site-booking__back svg{height:16px;width:16px}
.site-booking__schedule-toolbar{align-items:start;display:grid;gap:clamp(24px,4vw,64px);grid-template-columns:minmax(220px,300px) minmax(420px,520px);justify-content:space-between}
.site-booking__select-wrap{display:grid;gap:7px}
.site-booking__select-wrap label{font-size:.76rem;font-weight:800}
.site-booking__select,.site-booking__field input,.site-booking__field textarea{
  background:var(--site-background);
  border:1px solid var(--site-border);
  border-radius:12px;
  color:var(--site-text);
  min-height:46px;
  padding:10px 12px;
  width:100%
}
.site-booking__select:focus,.site-booking__field input:focus,.site-booking__field textarea:focus{border-color:var(--site-primary);outline:3px solid color-mix(in srgb,var(--site-primary) 18%,transparent)}
.site-booking__schedule-meta{align-items:center;display:flex;flex-wrap:wrap;gap:12px;justify-content:space-between}
.site-booking__legend{align-items:center;color:var(--site-muted);display:flex;font-size:.76rem;font-weight:700;gap:7px}
.site-booking__legend-dot{background:color-mix(in srgb,var(--site-primary) 18%,var(--site-surface));border:1px solid color-mix(in srgb,var(--site-primary) 42%,var(--site-border));border-radius:4px;height:13px;width:13px}
.site-booking__schedule-scroll{border-block:1px solid var(--site-border);overflow:auto}
.site-booking__schedule-grid{display:grid;min-width:max-content}
.site-booking__schedule-cell{align-items:center;border-bottom:1px solid color-mix(in srgb,var(--site-border) 70%,transparent);display:flex;justify-content:center;min-height:62px;padding:9px}
.site-booking__schedule-head{background:var(--site-surface);color:var(--site-muted);font-size:.72rem;font-weight:850;min-height:44px;position:sticky;top:0;z-index:2}
.site-booking__schedule-corner{justify-content:flex-start;left:0;position:sticky;z-index:3}
.site-booking__schedule-resource{background:var(--site-surface);justify-content:flex-start;left:0;position:sticky;z-index:1}
.site-booking__schedule-resource-copy{display:grid;gap:3px;min-width:0}
.site-booking__schedule-resource-copy strong{font-size:.84rem}
.site-booking__schedule-resource-copy small{color:var(--site-muted);font-size:.69rem}
.site-booking__schedule-slot{
  background:var(--booking-soft);
  border:0;
  border-radius:999px;
  color:var(--site-primary);
  cursor:pointer;
  font-size:.73rem;
  font-weight:850;
  height:36px;
  min-width:64px;
  padding:6px 8px;
  width:100%
}
.site-booking__schedule-slot:hover,.site-booking__schedule-slot[data-selected=true]{background:var(--site-primary);box-shadow:0 8px 18px color-mix(in srgb,var(--site-primary) 18%,transparent);color:var(--site-on-primary,#fff)}
.site-booking__schedule-unavailable{color:color-mix(in srgb,var(--site-muted) 45%,transparent);font-size:.8rem}
.site-booking__checkout{align-items:start;display:grid;gap:clamp(22px,4vw,40px);grid-template-columns:minmax(220px,.75fr) minmax(0,1.4fr)}
.site-booking__checkout-summary{display:grid;gap:16px}
.site-booking__checkout-summary h2{font-size:clamp(1.35rem,2.5vw,2rem)}
.site-booking__checkout-form{display:grid;gap:18px}
.site-booking__form{display:grid;gap:13px;grid-template-columns:repeat(2,minmax(0,1fr))}
.site-booking__field{display:grid;gap:7px}
.site-booking__field--wide{grid-column:1/-1}
.site-booking__field label{font-size:.77rem;font-weight:800}
.site-booking__field textarea{resize:vertical}
.site-booking__actions{align-items:center;display:flex;flex-wrap:wrap;gap:10px;justify-content:flex-end}
.site-booking__button{
  align-items:center;
  background:var(--site-primary);
  border:1px solid var(--site-primary);
  border-radius:var(--site-button-radius,max(11px,var(--site-radius)));
  color:var(--site-on-primary,#fff);
  cursor:pointer;
  display:inline-flex;
  font-weight:800;
  gap:8px;
  justify-content:center;
  min-height:46px;
  padding:10px 19px
}
.site-booking__button svg{height:17px;width:17px}
.site-booking__button--secondary{background:transparent;color:var(--site-primary)}
.site-booking__button:disabled{cursor:not-allowed;opacity:.55}
.site-booking__notice{background:var(--booking-soft);border:1px solid color-mix(in srgb,var(--site-primary) 24%,var(--site-border));border-radius:max(13px,var(--site-radius));color:var(--site-muted);padding:16px;text-align:center}
.site-booking__notice--error{background:color-mix(in srgb,#dc2626 7%,var(--site-surface));border-color:color-mix(in srgb,#dc2626 28%,var(--site-border));color:color-mix(in srgb,#dc2626 76%,var(--site-text))}
.site-booking__loading{align-items:center;display:flex;gap:9px;justify-content:center}
.site-booking__spinner{animation:site-booking-spin .8s linear infinite;border:2px solid var(--site-border);border-radius:50%;border-top-color:var(--site-primary);height:18px;width:18px}
.site-booking__success{align-items:center;background:linear-gradient(140deg,var(--booking-soft),var(--site-surface));display:grid;gap:14px;justify-items:center;min-height:360px;padding:clamp(32px,7vw,72px);text-align:center}
.site-booking__success-icon{align-items:center;background:var(--site-primary);border-radius:50%;box-shadow:0 18px 38px color-mix(in srgb,var(--site-primary) 25%,transparent);color:var(--site-on-primary,#fff);display:flex;height:72px;justify-content:center;width:72px}
.site-booking__success-icon svg{height:34px;width:34px}
.site-booking__success p{color:var(--site-muted);margin:0;max-width:480px}
.site-booking[data-presentation=page]{
  background:
    radial-gradient(circle at 8% 8%,color-mix(in srgb,var(--site-primary) 9%,transparent),transparent 30%),
    radial-gradient(circle at 92% 88%,color-mix(in srgb,var(--site-accent,var(--site-primary)) 8%,transparent),transparent 32%),
    var(--site-background);
  display:flex;
  min-height:calc(100svh - 80px);
  width:100%
}
.site-booking[data-presentation=page] .site-booking__shell{
  border:0;
  border-radius:0;
  box-shadow:none;
  display:flex;
  flex:1;
  flex-direction:column;
  min-height:calc(100svh - 80px);
  overflow:visible;
  width:100%
}
.site-booking[data-presentation=page] .site-booking__intro{
  padding-inline:max(clamp(20px,4vw,56px),calc((100% - 1360px) / 2))
}
.site-booking[data-presentation=page] .site-booking__progress{
  padding-inline:max(clamp(12px,4vw,56px),calc((100% - 1360px) / 2))
}
.site-booking[data-presentation=page] .site-booking__body{
  flex:1;
  padding:clamp(28px,4vw,58px) max(clamp(20px,4vw,56px),calc((100% - 1360px) / 2)) clamp(48px,6vw,86px)
}
.site-booking[data-presentation=page] .site-booking__workspace{
  margin-inline:auto;
  max-width:1360px;
  width:100%
}
.site-booking[data-presentation=page] .site-booking__checkout{
  margin-inline:auto;
  max-width:1180px;
  width:100%
}
.site-booking[data-presentation=page] .site-booking__success{flex:1;width:100%}
.site-booking[data-variant=professional] .site-booking__intro{background:linear-gradient(130deg,var(--site-text),color-mix(in srgb,var(--site-text) 82%,var(--site-primary)));color:var(--site-background)}
.site-booking[data-variant=professional] .site-booking__intro p{color:color-mix(in srgb,var(--site-background) 72%,transparent)}
.site-booking[data-variant=professional] .site-booking__eyebrow{color:color-mix(in srgb,var(--site-primary) 55%,var(--site-background))}
.site-booking[data-variant=professional] .site-booking__intro-icon{background:var(--site-background);color:var(--site-text)}
.site-booking[data-variant=professional] .site-booking__resources{grid-template-columns:repeat(auto-fit,minmax(min(220px,100%),1fr))}
.site-booking[data-variant=professional] .site-booking__resource{min-height:230px;padding:22px}
.site-booking[data-variant=professional] .site-booking__avatar{font-size:1.45rem;height:70px;width:70px}
.site-booking[data-variant=schedule] .site-booking__intro{background:var(--booking-soft)}
.site-booking[data-variant=venue-grid]{--booking-venue-line:color-mix(in srgb,var(--site-border) 82%,transparent)}
.site-booking[data-variant=venue-grid] .site-booking__intro{background:linear-gradient(118deg,color-mix(in srgb,var(--site-primary) 17%,var(--site-surface)),var(--site-surface) 64%)}
.site-booking[data-variant=venue-grid] .site-booking__body{padding-top:clamp(20px,3vw,38px)}
.site-booking__venue-layout{align-items:start;display:grid;gap:24px;grid-template-columns:minmax(250px,310px) minmax(0,1fr)}
.site-booking__venue-rail{background:var(--site-surface);border:1px solid var(--site-border);border-radius:max(16px,var(--site-radius));box-shadow:0 12px 34px color-mix(in srgb,var(--site-text) 6%,transparent);display:grid;gap:15px;padding:18px;position:sticky;top:18px}
.site-booking__venue-rail-heading{align-items:center;display:flex;font-family:var(--site-heading-font);font-size:.88rem;gap:9px}
.site-booking__venue-rail-heading>span{align-items:center;background:var(--site-primary);border-radius:50%;color:var(--site-on-primary,#fff);display:flex;font-size:.7rem;height:24px;justify-content:center;width:24px}
.site-booking__venue-services{display:grid;gap:8px;max-height:min(42vh,430px);overflow:auto}
.site-booking__venue-services>button{align-items:center;background:transparent;border:1px solid var(--site-border);border-radius:12px;color:var(--site-text);cursor:pointer;display:grid;gap:10px;grid-template-columns:auto minmax(0,1fr) 18px;padding:11px;text-align:left}
.site-booking__venue-services>button>span:nth-child(2){display:grid;gap:3px}
.site-booking__venue-services>button small{color:var(--site-muted)}
.site-booking__venue-services>button>svg{color:transparent;height:18px;width:18px}
.site-booking__venue-services>button[data-selected=true]{background:var(--booking-soft);border-color:color-mix(in srgb,var(--site-primary) 48%,var(--site-border))}
.site-booking__venue-services>button[data-selected=true]>svg{color:var(--site-primary)}
.site-booking__venue-resource-select{display:grid;gap:5px}
.site-booking__venue-resource-select>span{color:var(--site-muted);font-size:.66rem;font-weight:800;text-transform:uppercase}
.site-booking__venue-resource-select select{appearance:none;background:var(--site-background);border:1px solid var(--site-border);border-radius:11px;color:var(--site-text);font:inherit;font-size:.8rem;font-weight:750;padding:10px 34px 10px 11px;width:100%}
.site-booking__venue-schedule{background:var(--site-surface);border:1px solid var(--site-border);border-radius:max(16px,var(--site-radius));min-width:0;overflow:hidden}
.site-booking__week-navigation{align-items:center;border-bottom:1px solid var(--site-border);display:flex;gap:18px;justify-content:space-between;padding:16px 18px}
.site-booking__week-navigation>div{display:grid;gap:3px}
.site-booking__week-navigation>div>span{color:var(--site-muted);font-size:.72rem;font-weight:800;text-transform:uppercase}
.site-booking__week-navigation>span{display:flex;gap:5px}
.site-booking__week-navigation button{align-items:center;background:var(--booking-soft);border:0;border-radius:50%;color:var(--site-primary);cursor:pointer;display:flex;height:38px;justify-content:center;width:38px}
.site-booking__week-navigation button:last-child svg{transform:rotate(180deg)}
.site-booking__week-navigation button:disabled{cursor:not-allowed;opacity:.35}
.site-booking__week-navigation svg{height:17px;width:17px}
.site-booking__venue-date-jump{border-bottom:1px solid var(--site-border);padding:10px 18px;position:relative}
.site-booking__date-jump-toggle{align-items:center;background:var(--booking-soft);border:1px solid color-mix(in srgb,var(--site-primary) 24%,var(--site-border));border-radius:12px;color:var(--site-text);cursor:pointer;display:grid;gap:2px;grid-template-columns:30px minmax(0,1fr);padding:9px 13px;text-align:left}
.site-booking__date-jump-toggle>svg{color:var(--site-primary);grid-row:1/3;height:20px;width:20px}
.site-booking__date-jump-toggle>span{color:var(--site-muted);font-size:.62rem;font-weight:800;text-transform:uppercase}
.site-booking__date-jump-toggle>strong{font-size:.82rem}
.site-booking__date-jump-popover{background:var(--site-surface);border:1px solid var(--site-border);border-radius:max(14px,var(--site-radius));box-shadow:0 20px 60px color-mix(in srgb,var(--site-text) 18%,transparent);display:grid;gap:10px;left:18px;max-width:calc(100% - 36px);padding:12px;position:absolute;top:calc(100% - 4px);width:440px;z-index:15}
.site-booking__date-jump-popover>.site-booking__button{justify-self:end}
.site-booking__venue-grid-scroll{max-height:min(68svh,680px);overflow:auto;overscroll-behavior:contain}
.site-booking__venue-grid{display:grid;grid-template-columns:72px repeat(7,minmax(108px,1fr));min-width:828px}
.site-booking__venue-grid-corner,.site-booking__venue-grid-day{background:var(--site-background);border-bottom:1px solid var(--booking-venue-line);min-height:58px;padding:10px;position:sticky;top:0;z-index:2}
.site-booking__venue-grid-corner{align-items:center;display:flex;font-size:.7rem;font-weight:850;left:0;text-transform:uppercase;z-index:3}
.site-booking__venue-grid-day{display:grid;gap:2px;place-items:center;text-align:center}
.site-booking__venue-grid-day span{color:var(--site-muted);font-size:.7rem;font-weight:800;text-transform:uppercase}
.site-booking__venue-grid-day[data-current=true]{background:var(--booking-soft);color:var(--site-primary)}
.site-booking__venue-grid-time{align-items:center;background:var(--site-background);border-bottom:1px solid var(--booking-venue-line);color:var(--site-muted);display:flex;font-size:.68rem;font-weight:800;justify-content:center;left:0;min-height:46px;position:sticky;z-index:1}
.site-booking__venue-grid-cell{align-content:center;border-bottom:1px solid var(--booking-venue-line);border-left:1px solid var(--booking-venue-line);display:grid;gap:3px;grid-template-columns:repeat(2,minmax(0,1fr));height:64px;padding:3px}
.site-booking__venue-slot{align-items:center;background:color-mix(in srgb,#22c55e 10%,var(--site-surface));border:1px solid color-mix(in srgb,#22c55e 30%,var(--site-border));border-radius:7px;color:var(--site-text);cursor:pointer;display:flex;font-size:.66rem;justify-content:center;min-height:27px;padding:2px;text-align:center}
.site-booking__venue-slot:hover{background:var(--site-primary);border-color:var(--site-primary);color:var(--site-on-primary,#fff)}
.site-booking__venue-slot:disabled{cursor:wait;opacity:.45;pointer-events:none}
.site-booking__venue-unavailable{align-items:center;background:color-mix(in srgb,var(--site-muted) 4%,var(--site-surface));border-radius:6px;color:var(--site-muted);display:flex;font-size:.58rem;grid-column:1/-1;justify-content:center;min-height:24px;padding:3px;text-align:center}
.site-booking__venue-grid-cell[data-state=past]{background:linear-gradient(135deg,transparent 48%,color-mix(in srgb,var(--site-border) 70%,transparent) 49%,color-mix(in srgb,var(--site-border) 70%,transparent) 51%,transparent 52%)}
.site-booking__venue-schedule[aria-busy=true] .site-booking__venue-grid{opacity:.58;pointer-events:none}
.site-booking__venue-mobile{display:none}
.site-booking[data-variant=quick-slots] .site-booking__intro{background:linear-gradient(135deg,var(--site-text),color-mix(in srgb,var(--site-text) 84%,var(--site-primary)));color:var(--site-background)}
.site-booking[data-variant=quick-slots] .site-booking__intro p{color:color-mix(in srgb,var(--site-background) 72%,transparent)}
.site-booking__quick-layout{align-items:start;display:grid;gap:clamp(24px,4vw,52px);grid-template-columns:minmax(250px,.7fr) minmax(0,1.45fr)}
.site-booking__quick-services{display:flex;flex-wrap:wrap;gap:8px;position:sticky;top:18px}
.site-booking__quick-services>button{background:var(--site-surface);border:1px solid var(--site-border);border-radius:999px;color:var(--site-text);cursor:pointer;display:grid;gap:1px;padding:10px 15px;text-align:left}
.site-booking__quick-services>button span{color:var(--site-muted);font-size:.67rem}
.site-booking__quick-services>button[data-selected=true]{background:var(--site-primary);border-color:var(--site-primary);color:var(--site-on-primary,#fff)}
.site-booking__quick-services>button[data-selected=true] span{color:inherit;opacity:.78}
.site-booking__quick-feed{display:grid;gap:15px}
.site-booking__quick-day{background:var(--site-surface);border:1px solid var(--site-border);border-radius:max(14px,var(--site-radius));display:grid;gap:13px;padding:17px}
.site-booking__quick-day>header{display:grid;gap:2px}
.site-booking__quick-day>header span{color:var(--site-primary);font-size:.72rem;font-weight:850;text-transform:uppercase}
.site-booking__quick-day>div{display:grid;gap:8px;grid-template-columns:repeat(auto-fit,minmax(130px,1fr))}
.site-booking__quick-day button{background:var(--booking-soft);border:1px solid transparent;border-radius:12px;color:var(--site-text);cursor:pointer;display:grid;gap:3px;padding:12px;text-align:left}
.site-booking__quick-day button:hover{border-color:color-mix(in srgb,var(--site-primary) 42%,var(--site-border));transform:translateY(-1px)}
.site-booking__quick-day button span{color:var(--site-muted);font-size:.7rem}
.site-booking__restaurant-flow{display:grid;gap:clamp(20px,3vw,32px)}
.site-booking__restaurant-toolbar{display:flex;flex-wrap:wrap;gap:14px}
.site-booking__party-size{display:grid;gap:7px;min-width:min(220px,100%)}
.site-booking__party-size>span{font-size:.76rem;font-weight:800}
.site-booking__party-size select{background:var(--site-surface);border:1px solid var(--site-border);border-radius:10px;color:var(--site-text);min-height:44px;padding:8px 12px}
.site-booking__party-size select:focus{border-color:var(--site-primary);outline:3px solid color-mix(in srgb,var(--site-primary) 18%,transparent)}
.site-booking__dialog-backdrop{align-items:center;background:color-mix(in srgb,#020617 65%,transparent);display:flex;inset:0;justify-content:center;padding:18px;position:fixed;z-index:100000}
.site-booking__dialog-panel{background:var(--site-surface);border:1px solid var(--site-border);border-radius:clamp(18px,2vw,28px);box-shadow:0 30px 90px color-mix(in srgb,#020617 35%,transparent);max-height:min(760px,calc(100svh - 36px));max-width:940px;overflow:auto;padding:clamp(22px,4vw,38px);position:relative;width:100%}
.site-booking__dialog-title{font-family:var(--site-heading-font);font-size:clamp(1.35rem,2.5vw,2rem);margin:0 44px 22px 0}
.site-booking__dialog-close{align-items:center;background:var(--booking-soft);border:0;border-radius:50%;color:var(--site-text);cursor:pointer;display:flex;font-size:1.45rem;height:38px;justify-content:center;line-height:1;padding:0;position:absolute;right:18px;top:18px;width:38px}
.site-booking__dialog-panel .site-booking__checkout{grid-template-columns:minmax(210px,.7fr) minmax(0,1.3fr)}
.site-booking__dialog-panel .site-booking__checkout-summary>h2{display:none}
@keyframes site-booking-spin{to{transform:rotate(360deg)}}
@media(max-width:1180px){
  .site-booking__venue-layout{grid-template-columns:1fr}
  .site-booking__venue-rail{position:static}
  .site-booking__venue-services{display:flex;max-height:none;overflow:auto;padding-bottom:3px;scroll-snap-type:x proximity}
  .site-booking__venue-services>button{flex:0 0 min(255px,82vw);scroll-snap-align:start}
}
@media(max-width:860px){
  .site-booking__workspace[data-with-summary=true],.site-booking__checkout{grid-template-columns:1fr}
  .site-booking__aside{position:static}
  .site-booking__schedule-toolbar{grid-template-columns:1fr}
  .site-booking__summary{grid-template-columns:repeat(auto-fit,minmax(150px,1fr))}
  .site-booking__summary-title{grid-column:1/-1}
  .site-booking__quick-layout{grid-template-columns:1fr}
  .site-booking__quick-services{position:static}
  .site-booking__dialog-panel .site-booking__checkout{grid-template-columns:1fr}
}
@media(max-width:600px){
  .site-booking__intro{padding:22px 18px}
  .site-booking__intro-icon{height:48px;width:48px}
  .site-booking__body{padding:20px 16px 24px}
  .site-booking__progress{padding-inline:8px}
  .site-booking__progress-label{font-size:0;line-height:0}
  .site-booking__progress li[data-active=true] .site-booking__progress-label{font-size:.69rem;line-height:1.2}
  .site-booking__progress li:not(:last-child)::after{left:calc(50% + 14px);right:calc(-50% + 14px)}
  .site-booking__service-list .site-booking__card{grid-template-columns:auto minmax(0,1fr)}
  .site-booking__service-list .site-booking__selection-mark{display:none}
  .site-booking__form{grid-template-columns:1fr}
  .site-booking__actions{align-items:stretch;flex-direction:column-reverse}
  .site-booking__actions .site-booking__button{width:100%}
  .site-booking__venue-rail{padding:13px}
  .site-booking__venue-services{display:flex;overflow:auto;padding-bottom:3px;scroll-snap-type:x proximity}
  .site-booking__venue-services>button{flex:0 0 min(255px,82vw);scroll-snap-align:start}
  .site-booking__venue-grid-scroll{display:none}
  .site-booking__venue-date-jump{padding:10px 13px}
  .site-booking__date-jump-popover{left:13px;max-width:calc(100% - 26px);position:absolute;width:440px}
  .site-booking__venue-mobile{display:grid;gap:14px;padding:13px}
  .site-booking__venue-day-tabs{display:grid;gap:4px;grid-template-columns:repeat(7,minmax(0,1fr))}
  .site-booking__venue-day-tabs button{background:transparent;border:0;border-radius:10px;color:var(--site-text);display:grid;gap:2px;padding:8px 2px;text-align:center}
  .site-booking__venue-day-tabs button span{color:var(--site-muted);font-size:.6rem;font-weight:800;text-transform:uppercase}
  .site-booking__venue-day-tabs button[data-selected=true]{background:var(--site-primary);color:var(--site-on-primary,#fff)}
  .site-booking__venue-day-tabs button[data-selected=true] span{color:inherit;opacity:.8}
  .site-booking__venue-agenda{display:grid;gap:8px}
  .site-booking__venue-agenda>button{align-items:center;background:var(--booking-soft);border:1px solid transparent;border-radius:12px;color:var(--site-text);display:grid;gap:4px;grid-template-columns:72px minmax(0,1fr) auto;padding:12px;text-align:left}
  .site-booking__venue-agenda>button span{color:var(--site-muted);font-size:.76rem}
  .site-booking__venue-agenda>button small{color:var(--site-primary);font-size:.67rem;font-weight:800}
  .site-booking__dialog-backdrop{align-items:flex-end;padding:0}
  .site-booking__dialog-panel{border-radius:22px 22px 0 0;max-height:92svh;padding:22px 16px}
  .site-booking[data-presentation=page],.site-booking[data-presentation=page] .site-booking__shell{min-height:calc(100svh - 64px)}
}
@media(prefers-reduced-motion:reduce){
  .site-booking *{animation-duration:.01ms!important;scroll-behavior:auto!important;transition-duration:.01ms!important}
}
`;
